import { useEffect, useRef } from "react";
import { identityChanged, purgeSessionCaches } from "~/lib/pwa/session-cache-reset";

/**
 * T885 — empties the legacy identity caches when the signed-in identity changes. Best-effort,
 * for devices a pre-T885 worker still controls: under that worker root's data may itself come
 * from `tfc-route-data`, so a change can be missed until the new worker activates.
 */
export function useSessionCacheReset(identityKey: string | null): void {
  const previous = useRef<string | null | undefined>(undefined);
  useEffect(() => {
    if (identityChanged(previous.current, identityKey)) {
      void purgeSessionCaches(typeof caches === "undefined" ? undefined : caches);
    }
    previous.current = identityKey;
  }, [identityKey]);
}
